import { inject, computed } from 'vue';

export default function useUserHasPermission(permission) {
  const permissions = inject('permissions');
  const hasPermission = computed(() => permissions.value.includes(permission));
  return {
    hasPermission
  };
}
